import { SelfEnrollType } from '@zorro/clients';
import { planTooltipLabels } from '@zorro/types';
import { useRoles } from '@zorro/web/ui-utils';

import { PlanBadge } from '../PlanBadge';

type Props = {
  selfEnroll?: SelfEnrollType | null;
};

export const SelfEnrollBadge = ({ selfEnroll }: Props) => {
  const { isEmployeeOnlyRole } = useRoles();
  if (selfEnroll !== SelfEnrollType.SELF_ENROLL) {
    return null;
  }

  return (
    <PlanBadge
      tooltipLabel={
        isEmployeeOnlyRole
          ? planTooltipLabels.selfEnroll
          : planTooltipLabels.selfEnrollAdmin
      }
      label="Self-enroll"
      size="sm"
    />
  );
};
